/**
   * Un pago, este pago puede estar dirigido a diferentes áreas del sistema y puede ser ya sea de credito o de efectivo.
   * De credito se considera cuando se usa el crédito del cliente en el sistema, y de efectivo cuando se usa el desglose de pago
   * /// Si el pago tiene IdPagoEfectivo == null se considera que el origen del pago es de credito y se prohibe por medio de un CHECK haber pagado con credito una cobranza
   * TODO: Agregar el CHECK
   */
export interface Pago {
    IdRegistro: number;

    /**Id de pago en efectivo. Si es null se considera que este pago fue de crédito */
    IdPagoEfectivo: number | null;

    /**Pago en efectivo */
    PagoEfectivo: DesglosePagos;

    /**Id de pago de guias, que puede ser uno de los destinos del pago, otro destino puede ser abono al crédito de un cliente */
    IdPagoGuias: number;

    /**pago de guias, que puede ser uno de los destinos del pago, otro destino puede ser abono al crédito de un cliente */
    PagoGuias: PagoGuias;

}

//TODO: Ver como son dirigidos los pagos a cobranza, y como se manejan las revisiones cuando el cliente acepta algunas guias sí pero otras guías no

/**Tipo del pago de un conjunto de guias */
export enum TipoPagoGuias {
    Documentacion,
    EntregaDomicilio,
    EntregaOcurre
}

/**Dirige un pago a un conjunto de guias. Este NO es un abono al crédito de un cliente */
export interface PagoGuias {
    /**Llave primaria */
    IdRegistro: number;

    /**Tipo del pago de guias */
    Tipo: TipoPagoGuias;

    /**Guias que fueron pagadas con este pago */
    PagoGuiasGuias: PagoGuiasGuia[];
}


/**Mantiene la relacion muchos a muchos entre PagoGuias y las guias */
export interface PagoGuiasGuia {
    /**Id de la guias. Tiene un indice único indicando que no se puede pagar dos veces una guía */
    IdGuia: number;

    /**Id de pago guias */
    IdPagoGuias: number;

    /**pago guias */
    PagoGuias: PagoGuias;
}

/**Formas de pago del SAT que no son las de efectivo ya que esta la manejamos a parte en el desglose de pagos */
export enum FormaPagoNoEfectivo {
    Cheque = 1,
    Transferencia = 2,
    TarjetaCredito = 3,
    TarjetaDebito = 4,
}

/**Un pago a efectivo */
export interface DesglosePagos {
    IdRegistro: number;

    /**Parte del pago que fue en efectivo */
    Efectivo: number;

    /**
     * Listado de @see ConceptoPagoEfectivo  relacionado con esta entidad
     */
    ConceptoPagoEfectivos: ConceptoPagoEfectivo[];
}

/**Un concepto del PagoEfectivo con otras formas de pago */
export interface ConceptoPagoEfectivo {
    /**Llave primaria */
    IdRegistro: number;

    /**Id de PagoEfectivo */
    IdDesglosePagos: number;

    /**PagoEfectivo */
    DesglosePagos: DesglosePagos;

    /**Forma de pago */
    FormaPago: FormaPagoNoEfectivo;

    /**Monto de este concepto de pago */
    Monto: number;

    /**Ultimos 4 dígitos de la cuenta/tarjeta/cheque dependiendo de la forma de pago */
    UltDigitosCuenta: string;
}


// WEBPACK FOOTER //
// ./app/models/pago.ts